<template>
  <div>
    <Header></Header>
    <div class="download_other_apps">
      <div class="other_app_item">
        <div class="other_app_item_content appImage" style="background-image: url(../../../static/download/chrome.png)">
          <span class="other_app_item_title">谷歌浏览器</span>
          <div class="other_app_item_download_btn_list">
            <a
              href="https://download.vipcode.com/software/ChromeStandalone_64.0.3282.119_Setup.exe"
              class="other_app_item_download_btn"
            >windows下载</a>
            <a
              href="https://download.vipcode.com/software/googlechrome.dmg"
              class="other_app_item_download_btn"
            >Mac下载</a>
          </div>
        </div>
      </div>

      <div class="other_app_item">
        <div class="other_app_item_content appImage" style="background-image: url(../../../static/download/python.jpg)">
          <span class="other_app_item_title">Python客户端</span>
          <div class="other_app_item_download_btn_list">
            <a
              href="https://static-highcoding.oss-cn-zhangjiakou.aliyuncs.com/python-3.8.2.exe"
              class="other_app_item_download_btn"
            >windows下载</a>
            <a
              href="https://static-highcoding.oss-cn-zhangjiakou.aliyuncs.com/python-3.8.2-macosx10.9.pkg"
              class="other_app_item_download_btn"
            >Mac下载</a>
          </div>
        </div>
      </div>

      <div class="other_app_item" v-if="this.domainName==`roborobo.${institutionConfig.baseDomainName}` || this.domainName=='c.roborobo.cn'">
        <div class="other_app_item_content appImage" style="background-image: url(../../../static/download/vcpython.png)">
          <span class="other_app_item_title">VC-Python编译器</span>
          <div class="other_app_item_download_btn_list">
            <a
              href="https://vipcode-client.oss-cn-beijing.aliyuncs.com/Compiler/Release/vcEditer-1.0.0.1.exe"
              class="other_app_item_download_btn"
            >windows下载</a>
            <a
              href="https://vipcode-client.oss-cn-beijing.aliyuncs.com/Compiler/Release/vcEditer-1.0.0.dmg"
              class="other_app_item_download_btn"
            >Mac下载</a>
          </div>
        </div>
      </div>

      <div class="other_app_item" v-if="this.domainName==`roborobo.${institutionConfig.baseDomainName}` || this.domainName=='c.roborobo.cn'">
        <div class="other_app_item_content appImage" style="background-image: url(../../../static/download/rogic.png)">
          <span class="other_app_item_title">Rogic</span>
          <div class="other_app_item_download_btn_list">
            <a
              href="https://static-highcoding.oss-cn-zhangjiakou.aliyuncs.com/Rogic%202019.6.exe"
              class="other_app_item_download_btn"
            >windows下载</a>
          </div>
        </div>
      </div>


    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header";
import Foot from "@/components/foot";

export default {
  data() {
    return {
      domainName: ""
    };
  },
  components: {
    Header,
    Foot
  },
  created() {
    this.domainName = location.hostname;
  }
};
</script>

<style lang="scss">
.download_sec_1 {
  height: 560px;
  background: url(../../../static/download/onlineClass.png) no-repeat center;
}

.download_sec_1_btn_list {
  margin-left: 14%;
  padding-top: 180px;
  flex-direction: row;
  justify-content: space-between;
}

.download_btn {
  width: 214px;
  height: 60px;
  background: #ffffff;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #666666;
  cursor: pointer;
  margin-top: 20px;
}

.download_windows {
  background: #ffffff url(../../../static/download/windows.png) no-repeat left
    center;
  background-size: 33px;
  padding-left: 40px;
}

.download_mac {
  background: #ffffff url(../../../static/download/mac.png) no-repeat left
    center;
  background-size: 33px;
  padding-left: 40px;
}

.download_other_apps {
  width: 100%;
  min-height: 60vh;
  justify-content: center;
  margin: 20px auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.other_app_item {
  width: 580px;
  height: 192px;
  margin: 20px 10px;
  display: flex;
  justify-content: center;
  background: #ffffff;
  box-shadow: 0 1px 20px 0 rgba(18, 17, 15, 0.1);
  border-radius: 8px;
}

.other_app_item_no_img {
  width: 580px;
  height: 192px;
  margin: 20px 10px;
  display: flex;
  justify-content: center;
  background: #ffffff;
  box-shadow: 0 1px 20px 0 rgba(18, 17, 15, 0.1);
  border-radius: 8px;
}

.appImage {
  background: no-repeat left center;
  background-size: 75px 77px;
}

.other_app_item_content {
  margin-top: 50px;
  height: 97px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 130px;
}

.other_app_item_content_no_img {
  margin-top: 50px;
  height: 97px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.other_app_item_title {
  font-size: 24px;
  color: #525c65;
}

.other_app_item_download_btn_list {
  display: flex;
}

.other_app_item_download_btn {
  color: #02b3e4;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 118px;
  height: 32px;
  border: 1px solid #02b3e4;
  border-radius: 16px;
  margin-right: 32px;
  cursor: pointer;
  margin-top: 10px;
}

.other_app_item_download_btn:hover {
  background: #02b3e4;
  color: #ffffff;
}

@media screen and (max-width: 500px) {
  .other_app_item {
    width: 100%;
    height: 192px;
    margin: 20px 10px;
    display: flex;
    justify-content: start;
    background: #ffffff;
    box-shadow: 0 1px 20px 0 rgba(18, 17, 15, 0.1);
    border-radius: 8px;
  }
  .other_app_item_no_img {
    width: 580px;
    height: 192px;
    margin: 20px 10px;
    display: flex;
    justify-content: center;
    background: #ffffff;
    box-shadow: 0 1px 20px 0 rgba(18, 17, 15, 0.1);
    border-radius: 8px;
  }
  .other_app_item_download_btn_list {
    display: block;
  }
  .python_apps {
    margin-left: 20px;
    padding-left: 110px;
  }
  .chrome_apps {
    margin-left: 20px;
    padding-left: 110px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/download/download.vue